import React from 'react'
import clsx from 'clsx'
import { Typography } from '@material-ui/core'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import CMSText, { isPrismicText } from '../Global/CMSText'
import useTakeBackStyle from '../../components/TakeBack/TakeBack.style'
import Button from '../Button/Button'

type TProps = {
  settings: any
  handlePrevStep: () => void
  t: any
  activeStep: any
  show: any
}

const TakeBackHeader = ({
  settings,
  handlePrevStep,
  t,
  activeStep,
  show,
}: TProps) => {
  const classes = useTakeBackStyle()
  const title = settings?.data?.take_back_main_title
  const text = settings?.data?.take_back_text
  const previousStep = settings?.data?.previous_step

  return (
    <div className={clsx('takeBack__header', classes.takeBackHeaderContent)}>
      {isPrismicText(title) && (
        <Typography
          variant="h2"
          component="h1"
          className={clsx(
            'takeBack__header__title',
            classes.takeBackHeaderTitle
          )}
        >
          <CMSText
            asText
            data={title}
            defaultText={t('texts:takeBack:title')}
          />
        </Typography>
      )}
      {isPrismicText(text) && (
        <Typography
          variant="body1"
          component="div"
          className={clsx('takeBack__header__text', classes.takeBackHeaderText)}
        >
          <CMSText data={text} defaultText={t('texts:takeBack:text')} />
        </Typography>
      )}
      {(activeStep === 1 || (activeStep === 0 && !show)) && (
        <Button
          variant="text"
          className={clsx('takeBack__back-btn', classes.backLink)}
          onClick={() => handlePrevStep()}
        >
          <KeyboardBackspaceIcon className={classes.backArrow} />
          <CMSText
            asText
            data={previousStep}
            defaultText={t('texts:takeBack:previous_step')}
          />
        </Button>
      )}
    </div>
  )
}

export default TakeBackHeader
